
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as calendarWeRCyi5VLP_45qcj1oY_o_45CfpC7a5VTSQTXUhBg_45QvfMsMeta } from "/app/pages/calendar.vue?macro=true";
import { default as _91id_93T8hmhCj34KgP_456QhRwZEb1aeR93ACxWiXrtsImWNxeUMeta } from "/app/pages/set/[id].vue?macro=true";
import { default as reportingF6x4kViyKcsqk2PDelfpy9i9KLFBFtICBSQTxqvFdGsMeta } from "/app/pages/reporting.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as indexBYtkxt_452j14TYBCt2tlv0lUz4kZSU52BprivDliMUYUMeta } from "/app/layers/customer-module/pages/shop/index.vue?macro=true";
import { default as logoutUYmNrqQPxD4I1VCtdubU9c7hV2MRnNYob53UvKtTNwsMeta } from "/app/pages/auth/logout.vue?macro=true";
import { default as _91view_93gaigAxKokZaqnOqyAsOJ0M1uluFbCY44mvVtaNlmnSoMeta } from "/app/pages/sale/[view].vue?macro=true";
import { default as indexWDRknbic_45ldGPof626xeyoNcmW9RyR3rCTrEBQrhEKkMeta } from "/app/pages/tasks/index.vue?macro=true";
import { default as indexwTCjaHbPjVzsR9uCTV4OY9MTpkEp8KGFrUMeg8sgzcoMeta } from "/app/layers/customer-module/pages/my-hos/index.vue?macro=true";
import { default as _91mode_93ma1MU0tGlKgBcU8jpulb_WAE9UlJhlOdusUwaOza58MMeta } from "/app/pages/offer/[mode].vue?macro=true";
import { default as set_45overviewQnTWVLCkos2cCslradq6ltS7_C_oqHF9n4tNBPmBiJcMeta } from "/app/pages/set-overview.vue?macro=true";
import { default as _91mode_93bYXMkisd0YgJCKxAlwuFAjj6iaUnKY8j8aNls_NSqD0Meta } from "/app/pages/tasks/[mode].vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as _91view_937kaPgSg01_6ep40G1_45MAtx9fkZHRz2uN2lmV0hK07TQMeta } from "/app/pages/rental/[view].vue?macro=true";
import { default as inquiryYATwvrMAdO0vjtoWPMdkikOvHgn_45Ny6AtWsluOjFnG0Meta } from "/app/pages/tasks/inquiry.vue?macro=true";
import { default as comment_45centerTaDyJsMoblRxGHjsQX_45nUVpjS49XeIr_452LxHxbR3XgUMeta } from "/app/pages/comment-center.vue?macro=true";
import { default as _91view_934_TR_457jRFBQ8bxHcHaKk_xEX4AbWtujJSeAduj8GGS0Meta } from "/app/pages/invoice/[view].vue?macro=true";
import { default as liveATmLd0YJVOZgx53ey7cIGhyOZlUb_MQyTuJ0bsHqRI4Meta } from "/app/pages/logistics/live.vue?macro=true";
import { default as _91id_93jM1buJpr0qRzhDU8Z_f9tPazYQ_Xb6E9jqKArfeoSG0Meta } from "/app/pages/machinery/[id].vue?macro=true";
import { default as profileH1d3HevJJ5KMuiFaLAodBrr9ZY2WO693xejyAjbAkQcMeta } from "/app/layers/customer-module/pages/my-hos/profile.vue?macro=true";
import { default as indexxhblLZf7hup6SS_sRUmtBt2L_sGiKEIvU155k0vDW6oMeta } from "/app/layers/customer-module/pages/shop/buy/index.vue?macro=true";
import { default as overviewrq3i4571UB_45Htn7q9Xk9QheXkxWv9q_U_ySh2O_45cU8IMeta } from "/app/pages/driver/overview.vue?macro=true";
import { default as quick_45saleFE7_9Ua9KHg6yBcuXM2r1g0ap4el12oYp_45J9Hz5qKosMeta } from "/app/pages/sale/quick-sale.vue?macro=true";
import { default as indexFUnuyVGLNEFsfigYHL_45ruQOhsOSwMNzx6J7_0KTaLWcMeta } from "/app/layers/customer-module/pages/shop/rent/index.vue?macro=true";
import { default as _91id_93VZSJrAU7ZGa8Ke8SuwIF4N5YGWVcrcP_453M_xv5XSlFoMeta } from "/app/pages/driver/task/[id].vue?macro=true";
import { default as _91view_931ToUQRU_45rwcF34SPuoTYc7AOvGuz6ln_kDoav54briYMeta } from "/app/pages/logistics/[view].vue?macro=true";
import { default as _91view_936Ed8NClFgvNXfQZJ2UGuJwUpWOpmCRkFOfyRkrUPm_IMeta } from "/app/pages/marketing/[view].vue?macro=true";
import { default as _91id_93c4SNdpCCSfILzclAKZMeIrJVQ3bC_1Q08KzQbbRWpxQMeta } from "/app/layers/customer-module/pages/my-hos/sale/[id].vue?macro=true";
import { default as _91id_93tSPIRlx3XYEC2Cn5u4t89BTmGfrCR48YnjCd7G4ZamUMeta } from "/app/pages/uvv-service/[id].vue?macro=true";
import { default as index5Zac3mO7lpzFb8g4acyqzFgGTaViIFjJNZByh5xfNTEMeta } from "/app/layers/customer-module/pages/my-hos/sale/index.vue?macro=true";
import { default as machineryMmp6AWeMvub9bzzEJGqWYj0gYYxyz39JeUli6MIsYjQMeta } from "/app/pages/service/machinery.vue?macro=true";
import { default as bookinghX5UxUJIvFlkOn9T01P3zXrTlWeBwwW_zeBElXF0utUMeta } from "/app/layers/customer-module/pages/shop/rent/booking.vue?macro=true";
import { default as logistics_45planningjY7ApLt230RvqMEfmAX7rPhtdCz96mF_yCRAzgZHeu4Meta } from "/app/pages/logistics-planning.vue?macro=true";
import { default as _91id_9332RxSta8GZNNeJs_45f_WAeY_45s64wJ05FlL5oy0DNzwSgMeta } from "/app/layers/customer-module/pages/my-hos/rental/[id].vue?macro=true";
import { default as machineryCccDEJnokHbtod5DyfQMkoMkpRDeO8SushIbL4IoCgQMeta } from "/app/pages/overview/machinery.vue?macro=true";
import { default as sale_45ordervhRaPQXfC0L9UYZvZfJF_8Sri9_Syi7rZQYCElfmnogMeta } from "/app/pages/service/sale-order.vue?macro=true";
import { default as _91id_93E13EuUd6pZ7sVnFEl4P4Bl7fBPK1flLwBea4WpMl36kMeta } from "/app/layers/customer-module/pages/shop/checkout/[id].vue?macro=true";
import { default as verify_45request7Vt8HxNlJqaWGMrXrUbor9MasvazK_1fyoNC9CiZfPAMeta } from "/app/pages/auth/verify-request.vue?macro=true";
import { default as preparationi5fuXvpx0qruzzvydswcJjgJJsWCcX2NzMchh3P1TPYMeta } from "/app/pages/invoice/preparation.vue?macro=true";
import { default as indexeFc_P7o4uGMGa8oQGSDp7jaGEWkgvq9VNEKwaSjrA_QMeta } from "/app/layers/customer-module/pages/my-hos/rental/index.vue?macro=true";
import { default as _91id_93faK8Tqi4BiBe_5cu3ygh2Cnv3wcQZLjoiFoNXnOjmOAMeta } from "/app/layers/customer-module/pages/my-hos/special/[id].vue?macro=true";
import { default as indexR5DAiOa5_X9E7CGmbv5BEHOp48fGdpbQZnqz500qpicMeta } from "/app/layers/customer-module/pages/shop/checkout/index.vue?macro=true";
import { default as storage_45tool_45bundlehsZAGm_45eaA5xIv4hkpLGTLoovtyQp5zZBCCCvl0zI68Meta } from "/app/pages/storage-tool-bundle.vue?macro=true";
import { default as orderiZT5kgawcKgK1Ul15x5IJdVFnWyB9XoFC7h8FXD3dIUMeta } from "/app/pages/internal-costs/order.vue?macro=true";
import { default as indexW9DvLYVeM6x7dVVax2M7ZCCvhgq4KTAfe3fls_45eANkwMeta } from "/app/layers/customer-module/pages/my-hos/special/index.vue?macro=true";
import { default as indexmLjZ9U7VhSJVwJ9Fw0wG4J8gPpTWHFp8KQnLPp6f7JkMeta } from "/app/pages/rental/pricing/index.vue?macro=true";
import { default as _91view_93fiYozADF0qNQGv0hjxQSgdMW88I92oBntueVdh3QoskMeta } from "/app/pages/special-order/[view].vue?macro=true";
import { default as _91id_93hcbAGPE5FmpO6opu80lhzP_451Q8zvQG4ugIdk7tVAItUMeta } from "/app/layers/customer-module/pages/my-hos/machinery/[id].vue?macro=true";
import { default as storage_45toola4bYQod5LJ43LDFcF6X3kYc2My2M5MyiS59GEuYK170Meta } from "/app/pages/overview/storage-tool.vue?macro=true";
import { default as sale_45issuanceEpc4TNijfdS0MyCEE3RUy_45DyBWe9o80VAAzvWr0ZaqYMeta } from "/app/pages/service/sale-issuance.vue?macro=true";
import { default as indexBr3XGiJKYhs9vBDvOHgcYKnFpOaqMHPxUcC_45u_45EkumoMeta } from "/app/pages/delivery-vehicle/index.vue?macro=true";
import { default as index7KOlwafUghM24Bs4XR1ys86EBKnh_45u2OdsCQd_QRDIsMeta } from "/app/layers/customer-module/pages/my-hos/machinery/index.vue?macro=true";
import { default as _91cuid_93Klarle8Yk3MM9aM_45zeQ4t7rqISV7BDZZu_rgfbrlqWoMeta } from "/app/pages/offer-reporting/[cuid].vue?macro=true";
import { default as _91view_93nbUDyQmxH1dNJPT_45QYQFYyF4kyGEIxrv2sIJFjQ7BDkMeta } from "/app/pages/service-project/[view].vue?macro=true";
import { default as maintainr_o_45DJCVkPAf6ztkHqF_PsD8u694SHuC50xkD06eE_45gMeta } from "/app/pages/machinery-type/maintain.vue?macro=true";
import { default as indexRKs_45DLwBGvmefdmPFLpjQScIEW5yWbET_GNsOs_45FkD4Meta } from "/app/layers/customer-module/pages/my-hos/quick-sale/index.vue?macro=true";
import { default as overviewP8hFSJUnFXfFa8c8eMAWFoETy8J7Ck_l6QAVDAd7wUUMeta } from "/app/pages/tracker-sensor/overview.vue?macro=true";
import { default as machineryWVMXKjtzSu85z7CDwghF_rkA1AtcH8lZRdINLPoCiXUMeta } from "/app/pages/internal-costs/machinery.vue?macro=true";
import { default as _91id_93VblqvCEZ2WlzwCrt20KwSSoriCRzCiGZhlnR8uEzqfAMeta } from "/app/pages/machinery-accessory/[id].vue?macro=true";
import { default as planning9tJNiL_457UW3QudJjXMXbgEYmX5L1A6BtXaHNUZdWHXQMeta } from "/app/pages/service-project/planning.vue?macro=true";
import { default as all5A1YpT3a2RIwSTQpAWoUcS_rofAZEfsyofj2DOHfcbcMeta } from "/app/pages/freelancer-sales/sale/all.vue?macro=true";
import { default as _91view_93_KH8LEIHbcvmN3WXrBNBuLWpkFdIMEcCe7eB8wJg_GgMeta } from "/app/pages/machinery-creation/[view].vue?macro=true";
import { default as marketplacesTuL_45xtxCPS__vGEozdJ4ARkrZZgeOyFDEbUXyjKWJ6IMeta } from "/app/pages/online-sales/marketplaces.vue?macro=true";
import { default as openqg09EbTxEaufgewuQf1J2l7T4S68IzvPd7o1oWQS0b8Meta } from "/app/pages/customer-registration/open.vue?macro=true";
import { default as indexANTpvXsX28gevRhAa4rurNk_FvyeDYS95p0kZkxDKx4Meta } from "/app/layers/customer-module/pages/my-hos/rental/manage/index.vue?macro=true";
import { default as foreign_45machinery_45LYn7KvBfay89Wli7IRP8X6qNL2FRtUcbUbZxD5hUyMMeta } from "/app/pages/overview/foreign-machinery.vue?macro=true";
import { default as customerssQzxgd7SQ6wL3lWLJSEEvWlT76AwlD2DPNre1viZsWYMeta } from "/app/pages/customer-overview/customers.vue?macro=true";
import { default as _91id_93hHDqni2eh8pUfvxH3U0iqTk1J4BtUjr7QvnW_FAEAfUMeta } from "/app/layers/customer-module/pages/my-hos/service-project/[id].vue?macro=true";
import { default as machinery_45accessory8fWbJyPHl2VtjFXe5lcBGBIxa7xkGAfgDarCTiZt50kMeta } from "/app/pages/service/machinery-accessory.vue?macro=true";
import { default as index4TUu0seolxiRvQmJR62W_45nhTYEUUKM8Qr3oxWBtvFzIMeta } from "/app/pages/service/repair-[type]/index.vue?macro=true";
import { default as indexjb21qcHt_NIf99CCYHsHPFIsE9IdCB99pJy1ZL5L7m8Meta } from "/app/layers/customer-module/pages/my-hos/service-project/index.vue?macro=true";
import { default as machinery_45accessorytgTDsxonVl6IzTV5LyMJhPndbgAo_T0Z3bEkgvhQiAEMeta } from "/app/layers/customer-module/pages/shop/buy/machinery-accessory.vue?macro=true";
import { default as _91view_936fqh5dU1AxhgyzWtMtOP1QPrVJC7JFgz2tygYjdPpOwMeta } from "/app/pages/storage-tool-creation/[view].vue?macro=true";
import { default as configuration1_45NelNxTwmu1fsS0f6G1zUYvE4sOVZ0sxwcxaIxnZvMMeta } from "/app/pages/tracker-sensor/configuration.vue?macro=true";
import { default as _91mode_93Hu9iKas0CqThBSRIRFAwe4BBnbBNkS6msnm4mYO_451CkMeta } from "/app/pages/inbound-logistics-task/[mode].vue?macro=true";
import { default as active_45rentalspCtW7a4RAdcoEaI36QlKraNtzRDmgff6DVAfP7L1P4QMeta } from "/app/pages/internal-fleet/active-rentals.vue?macro=true";
import { default as _91id_93cHAN_45VcgzYfXZDTJ_WI84tFt8dX4dDLaOQJvdKLYpucMeta } from "/app/layers/customer-module/pages/my-hos/foreign-machinery/[id].vue?macro=true";
import { default as _91id_93kFhmkIB8U8dwrVX0w6wyQsbzY1yepvq3XTnHdGVRQ_45EMeta } from "/app/pages/service-project/external/[id].vue?macro=true";
import { default as storeNeQ4VM2S1wQGkFi4vB_Vk2mHffmSTTmqTglvlPswegsMeta } from "/app/pages/external-storage-inbound/store.vue?macro=true";
import { default as loadxzdCGx9C38vhLv3foANvX9edV4slMN4Izrx_45SSUj1nAMeta } from "/app/pages/external-storage-outbound/load.vue?macro=true";
import { default as _91id_93MbMxj87rHFFtb0Zv5T0dBTUz5CB_45rQk5HMQ_QkLI_yAMeta } from "/app/pages/external-storage-position/[id].vue?macro=true";
import { default as _91cuid_93DGIaPHnSnMyf4pJvJ_XYb2X8HJldRyHX4KzOw7jZJlYMeta } from "/app/pages/logistics-details/drive/[cuid].vue?macro=true";
import { default as indexJI8rBLrPXTsvhp_45xmZeYl3e_45XFr7J2iggLQHb1lUQM4Meta } from "/app/layers/customer-module/pages/my-hos/foreign-machinery/index.vue?macro=true";
import { default as customer_45userQfBbAGmvrMBahd8JtZTHzvUUKSDAfeCBrawVmzG81VUMeta } from "/app/pages/customer-overview/customer-user.vue?macro=true";
import { default as completedP0MNE9tY7IxSxTmvTt6S2kiuiKyhJAoY_45Oj_45Ob3jSZYMeta } from "/app/pages/customer-registration/completed.vue?macro=true";
import { default as company_45vehicles4xxOcXBK0ojNNxSTImiOoorl_ctyTb6dd_45jyzWPQ328Meta } from "/app/pages/internal-fleet/company-vehicles.vue?macro=true";
import { default as _91cuid_93SXKYga2EWwYfltdr_453e8gzWzj4J2_c7KjFnoE39EmZIMeta } from "/app/pages/logistics-details/issued/[cuid].vue?macro=true";
import { default as fitter_45issuanceXUgNnQlsyqHXlPfC_45KG6q4JXIxaRLGyqa85EKoHZxA8Meta } from "/app/pages/service-project/fitter-issuance.vue?macro=true";
import { default as approvewq9eqm7cWJlMhATbNnQ9Y95th3PSbjepl7d4AMkxO8kMeta } from "/app/pages/external-storage-inbound/approve.vue?macro=true";
import { default as requestesQ10W0H3W0qGCdQCmDF8Ysq1yPIqIqvpBNUDu3XvGQMeta } from "/app/pages/external-storage-inbound/request.vue?macro=true";
import { default as storage_45productnqy3JfD9lrECt9xHenOMo6DEwRzYJTGQRnzykhAFArEMeta } from "/app/pages/external-storage/storage-product.vue?macro=true";
import { default as my_45active_45rentalsn6gOQ7pZ_Z4g06x_lPTA49oTZdc8CEsKOHe30g0HTNgMeta } from "/app/pages/internal-fleet/my-active-rentals.vue?macro=true";
import { default as released_45machinerySKFZBXJRGg8BJNCgEVKxYV13QtWCmLzN92DCcV1Ly8UMeta } from "/app/pages/partner-sales/released-machinery.vue?macro=true";
import { default as requestAfklfI_45oDMyHg23LgnS80dZ4YO7VSc4v5YG_T_45nd_45J4Meta } from "/app/pages/external-storage-outbound/request.vue?macro=true";
import { default as terminated_45rentalsuXFgxhXpyLmmNa1W5xxKYMl_45gW8212_wtXSQImQ6GB0Meta } from "/app/pages/internal-fleet/terminated-rentals.vue?macro=true";
import { default as storage_45tool_45categoriesCGSC_45mrIyRL4KDt9N8xLxF1c77GX7niXN8XhI5Ajbe0Meta } from "/app/pages/marketing/storage-tool-categories.vue?macro=true";
import { default as _91accessCode_93CMRSyjJpDDxAU7r_45cYpK2fNS9CxCU11jhX8x69yQD98Meta } from "/app/layers/customer-module/pages/my-hos/rental/manage/[accessCode].vue?macro=true";
import { default as machinery_45accessoryRxD1HKcgeyhoo88yAqjhwJpdbo74GxyZS8Yli1TTlmwMeta } from "/app/pages/internal-costs/machinery-accessory.vue?macro=true";
import { default as _91cuid_93ZEW65wnY7lKnoDI2q6saArod8C4yL0Fv3_siw8AOVzMMeta } from "/app/pages/logistics-details/collected/[cuid].vue?macro=true";
import { default as position_45templatest_Rk_4nCww_m49xY16mz45zdFog46vC8CgJwz1SEClkMeta } from "/app/pages/offer-templates/position-templates.vue?macro=true";
import { default as released_45machineryBkPBievxp68nAwdiALsxzY28fq00DNG3gHK_Br_EXdIMeta } from "/app/pages/freelancer-sales/released-machinery.vue?macro=true";
import { default as external_45workshop_45employeesNwfRDXjo36L1L2AKY2V1tScKs_1iqOS1wEOE4oND4AcMeta } from "/app/pages/service/external-workshop-employees.vue?macro=true";
import { default as retrieved_45positionsloWoaNSV10k8hJtnlS40C_45LTj8KHb91ZPHEBkEqsAGUMeta } from "/app/pages/external-storage/retrieved-positions.vue?macro=true";
import { default as _91view_93J0w1Sj3188SppTfH3wUO4wisjZRgD9k_B2hkD0XjJdkMeta } from "/app/pages/freelancer-sales/sale/current/[view].vue?macro=true";
import { default as _91mode_93sidPu4b7i62htUvTjaCkkOh4pMdSL1fq0ClDITQjUSEMeta } from "/app/pages/external-storage-outbound/task/[mode].vue?macro=true";
import { default as positions_45in_45storageDdqtm2ZMv2abp5XJBNDtxczXSIEZQArX24rxC2CFdH0Meta } from "/app/pages/external-storage/positions-in-storage.vue?macro=true";
import { default as _91id_934fKCFxyTx17CEQEU5_45qORg0op_45etM97OKyFVkxmLT1kMeta } from "/app/layers/customer-module/pages/my-hos/service-project/reporting/[id].vue?macro=true";
import { default as external_45stakeholders0eZF5BZ8JndeKnDEQLoqHZ4SEs_h_45KUKh1i23HdZ32IMeta } from "/app/pages/service-project/external-stakeholders.vue?macro=true";
import { default as indexmB4lxjsfAoiDvL9ZxLz5gqHR9dHJ_QcjxsXKCeY0BNoMeta } from "/app/layers/customer-module/pages/my-hos/service-project/reporting/index.vue?macro=true";
import { default as _91machineryId_93KL5hmeLnuHVIBDB3Wm4lRqjedwvsqU62W6_45ZfIxbp34Meta } from "/app/pages/rental/pricing/machinery/[machineryId].vue?macro=true";
import { default as service_45project_45returnyvHj2ATVUMixdYouNNlFjpvOwbtZ96mus3HdizOOSVgMeta } from "/app/pages/service-project/service-project-return.vue?macro=true";
import { default as _91_91defectId_93_939Aybp1g5N_45cnVTL_45T4LeOudo_45yNASaLqdDMmDep_45LKoMeta } from "/app/pages/service/repair-[type]/[id]/[[defectId]].vue?macro=true";
import { default as _91view_93Ju43qEIBX27LhI0bmbleaEakl0sAsJBo9odeq9ophvcMeta } from "/app/pages/service-project/external/overview/[view].vue?macro=true";
import { default as _91id_93cnBOs3rm_9wKhFaEND0fLPQ7goYmIpuPU9YvoA2yPx4Meta } from "/app/pages/driver/external-storage/inbound-task/[id].vue?macro=true";
import { default as used_45storage_45space_45check9HrwRlzDhE060LRWBQVLlgXprjV_Fd70CROkwMnIHDwMeta } from "/app/pages/external-storage/used-storage-space-check.vue?macro=true";
import { default as position_45template_45bundlesxYO7QreDBf5yNk_giuGqMd_45B71DfjyT4YKi5bo_rzIUMeta } from "/app/pages/offer-templates/position-template-bundles.vue?macro=true";
import { default as other_45invoice_45recipients5JOFrGJXgz8heP5fK7yKGL_45RAqCd5FElU3rUxdjqgWsMeta } from "/app/pages/customer-overview/other-invoice-recipients.vue?macro=true";
import { default as _91id_9373r13N275qy9rzY32HieRxUR9d5gtNQOKnHTH8TXoOcMeta } from "/app/pages/driver/external-storage/outbound-task/[id].vue?macro=true";
import { default as storage_45ride0dhU3UZCm2UQ1x9_jagOzdGnU3wJPXpb8uNzJQKZIJMMeta } from "/app/pages/external-storage-administration/storage-ride.vue?macro=true";
import { default as storage_45user30mxQzU9YVQM0OsLwXFeytNqa_MqsTfy_W_45GBmr_45xc8Meta } from "/app/pages/external-storage-administration/storage-user.vue?macro=true";
import { default as _91storagePositionId_93B2XNPwCMQGQ3kKYjQH9zprQStZ4v3COzGKxKwTylKXkMeta } from "/app/pages/external-storage/invoicing/[storagePositionId].vue?macro=true";
import { default as storage_45project9mw75A1GX5MCuxBb7Wlf3ucLBcq8CpYleQdHF3zLBbgMeta } from "/app/pages/external-storage-administration/storage-project.vue?macro=true";
import { default as _91machineryTypeId_930WcZk9GQdSsHO3vnFIZxlUq3W0AwZTOFrghDQGeyeCkMeta } from "/app/pages/rental/pricing/machinery-type/[machineryTypeId].vue?macro=true";
import { default as storage_45reportingQXoqLmegToEtd_45Py6OY7pRi817mOmpg51PciGQPyhtEMeta } from "/app/pages/external-storage-administration/storage-reporting.vue?macro=true";
import { default as storage_45load_45carrierff_45wqfpZ22sbl89Aur0QqVH_45ywvgqZKxh_45gAA2VPfkMMeta } from "/app/pages/external-storage-administration/storage-load-carrier.vue?macro=true";
import { default as logistics_45task_45overviewqiP7hg8ne4e8t0QfTvXseXLY2WTLyTnWTbrWZQbZty8Meta } from "/app/pages/external-storage-administration/logistics-task-overview.vue?macro=true";
import { default as storage_45fixed_45delivery_45vehiclesySqLROThnpiFzYeOctvpoQ5d6mI3Ss1VlARZlDAozZsMeta } from "/app/pages/external-storage-administration/storage-fixed-delivery-vehicles.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/app/pages/calendar.vue")
  },
  {
    name: "set-id",
    path: "/set/:id()",
    meta: _91id_93T8hmhCj34KgP_456QhRwZEb1aeR93ACxWiXrtsImWNxeUMeta || {},
    component: () => import("/app/pages/set/[id].vue")
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/app/pages/reporting.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "shop",
    path: "/shop",
    meta: indexBYtkxt_452j14TYBCt2tlv0lUz4kZSU52BprivDliMUYUMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/index.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: logoutUYmNrqQPxD4I1VCtdubU9c7hV2MRnNYob53UvKtTNwsMeta || {},
    component: () => import("/app/pages/auth/logout.vue")
  },
  {
    name: "sale-view",
    path: "/sale/:view()",
    component: () => import("/app/pages/sale/[view].vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    component: () => import("/app/pages/tasks/index.vue")
  },
  {
    name: "my-hos",
    path: "/my-hos",
    meta: indexwTCjaHbPjVzsR9uCTV4OY9MTpkEp8KGFrUMeg8sgzcoMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/index.vue")
  },
  {
    name: "offer-mode",
    path: "/offer/:mode()",
    component: () => import("/app/pages/offer/[mode].vue")
  },
  {
    name: "set-overview",
    path: "/set-overview",
    component: () => import("/app/pages/set-overview.vue")
  },
  {
    name: "tasks-mode",
    path: "/tasks/:mode()",
    component: () => import("/app/pages/tasks/[mode].vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "rental-view",
    path: "/rental/:view()",
    component: () => import("/app/pages/rental/[view].vue")
  },
  {
    name: "tasks-inquiry",
    path: "/tasks/inquiry",
    meta: inquiryYATwvrMAdO0vjtoWPMdkikOvHgn_45Ny6AtWsluOjFnG0Meta || {},
    component: () => import("/app/pages/tasks/inquiry.vue")
  },
  {
    name: "comment-center",
    path: "/comment-center",
    component: () => import("/app/pages/comment-center.vue")
  },
  {
    name: "invoice-view",
    path: "/invoice/:view()",
    component: () => import("/app/pages/invoice/[view].vue")
  },
  {
    name: "logistics-live",
    path: "/logistics/live",
    component: () => import("/app/pages/logistics/live.vue")
  },
  {
    name: "machinery-id",
    path: "/machinery/:id()",
    meta: _91id_93jM1buJpr0qRzhDU8Z_f9tPazYQ_Xb6E9jqKArfeoSG0Meta || {},
    component: () => import("/app/pages/machinery/[id].vue")
  },
  {
    name: "my-hos-profile",
    path: "/my-hos/profile",
    meta: profileH1d3HevJJ5KMuiFaLAodBrr9ZY2WO693xejyAjbAkQcMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/profile.vue")
  },
  {
    name: "shop-buy",
    path: "/shop/buy",
    meta: indexxhblLZf7hup6SS_sRUmtBt2L_sGiKEIvU155k0vDW6oMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/buy/index.vue")
  },
  {
    name: "driver-overview",
    path: "/driver/overview",
    component: () => import("/app/pages/driver/overview.vue")
  },
  {
    name: "sale-quick-sale",
    path: "/sale/quick-sale",
    component: () => import("/app/pages/sale/quick-sale.vue")
  },
  {
    name: "shop-rent",
    path: "/shop/rent",
    meta: indexFUnuyVGLNEFsfigYHL_45ruQOhsOSwMNzx6J7_0KTaLWcMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/rent/index.vue")
  },
  {
    name: "driver-task-id",
    path: "/driver/task/:id()",
    component: () => import("/app/pages/driver/task/[id].vue")
  },
  {
    name: "logistics-view",
    path: "/logistics/:view()",
    component: () => import("/app/pages/logistics/[view].vue")
  },
  {
    name: "marketing-view",
    path: "/marketing/:view()",
    component: () => import("/app/pages/marketing/[view].vue")
  },
  {
    name: "my-hos-sale-id",
    path: "/my-hos/sale/:id()",
    meta: _91id_93c4SNdpCCSfILzclAKZMeIrJVQ3bC_1Q08KzQbbRWpxQMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/sale/[id].vue")
  },
  {
    name: "uvv-service-id",
    path: "/uvv-service/:id()",
    meta: _91id_93tSPIRlx3XYEC2Cn5u4t89BTmGfrCR48YnjCd7G4ZamUMeta || {},
    component: () => import("/app/pages/uvv-service/[id].vue")
  },
  {
    name: "my-hos-sale",
    path: "/my-hos/sale",
    meta: index5Zac3mO7lpzFb8g4acyqzFgGTaViIFjJNZByh5xfNTEMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/sale/index.vue")
  },
  {
    name: "service-machinery",
    path: "/service/machinery",
    component: () => import("/app/pages/service/machinery.vue")
  },
  {
    name: "shop-rent-booking",
    path: "/shop/rent/booking",
    meta: bookinghX5UxUJIvFlkOn9T01P3zXrTlWeBwwW_zeBElXF0utUMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/rent/booking.vue")
  },
  {
    name: "logistics-planning",
    path: "/logistics-planning",
    component: () => import("/app/pages/logistics-planning.vue")
  },
  {
    name: "my-hos-rental-id",
    path: "/my-hos/rental/:id()",
    meta: _91id_9332RxSta8GZNNeJs_45f_WAeY_45s64wJ05FlL5oy0DNzwSgMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/rental/[id].vue")
  },
  {
    name: "overview-machinery",
    path: "/overview/machinery",
    component: () => import("/app/pages/overview/machinery.vue")
  },
  {
    name: "service-sale-order",
    path: "/service/sale-order",
    component: () => import("/app/pages/service/sale-order.vue")
  },
  {
    name: "shop-checkout-id",
    path: "/shop/checkout/:id()",
    meta: _91id_93E13EuUd6pZ7sVnFEl4P4Bl7fBPK1flLwBea4WpMl36kMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/checkout/[id].vue")
  },
  {
    name: "auth-verify-request",
    path: "/auth/verify-request",
    meta: verify_45request7Vt8HxNlJqaWGMrXrUbor9MasvazK_1fyoNC9CiZfPAMeta || {},
    component: () => import("/app/pages/auth/verify-request.vue")
  },
  {
    name: "invoice-preparation",
    path: "/invoice/preparation",
    component: () => import("/app/pages/invoice/preparation.vue")
  },
  {
    name: "my-hos-rental",
    path: "/my-hos/rental",
    meta: indexeFc_P7o4uGMGa8oQGSDp7jaGEWkgvq9VNEKwaSjrA_QMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/rental/index.vue")
  },
  {
    name: "my-hos-special-id",
    path: "/my-hos/special/:id()",
    meta: _91id_93faK8Tqi4BiBe_5cu3ygh2Cnv3wcQZLjoiFoNXnOjmOAMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/special/[id].vue")
  },
  {
    name: "shop-checkout",
    path: "/shop/checkout",
    meta: indexR5DAiOa5_X9E7CGmbv5BEHOp48fGdpbQZnqz500qpicMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/checkout/index.vue")
  },
  {
    name: "storage-tool-bundle",
    path: "/storage-tool-bundle",
    component: () => import("/app/pages/storage-tool-bundle.vue")
  },
  {
    name: "internal-costs-order",
    path: "/internal-costs/order",
    component: () => import("/app/pages/internal-costs/order.vue")
  },
  {
    name: "my-hos-special",
    path: "/my-hos/special",
    meta: indexW9DvLYVeM6x7dVVax2M7ZCCvhgq4KTAfe3fls_45eANkwMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/special/index.vue")
  },
  {
    name: "rental-pricing",
    path: "/rental/pricing",
    component: () => import("/app/pages/rental/pricing/index.vue")
  },
  {
    name: "special-order-view",
    path: "/special-order/:view()",
    component: () => import("/app/pages/special-order/[view].vue")
  },
  {
    name: "my-hos-machinery-id",
    path: "/my-hos/machinery/:id()",
    meta: _91id_93hcbAGPE5FmpO6opu80lhzP_451Q8zvQG4ugIdk7tVAItUMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/machinery/[id].vue")
  },
  {
    name: "overview-storage-tool",
    path: "/overview/storage-tool",
    component: () => import("/app/pages/overview/storage-tool.vue")
  },
  {
    name: "service-sale-issuance",
    path: "/service/sale-issuance",
    component: () => import("/app/pages/service/sale-issuance.vue")
  },
  {
    name: "delivery-vehicle",
    path: "/delivery-vehicle",
    component: () => import("/app/pages/delivery-vehicle/index.vue")
  },
  {
    name: "my-hos-machinery",
    path: "/my-hos/machinery",
    meta: index7KOlwafUghM24Bs4XR1ys86EBKnh_45u2OdsCQd_QRDIsMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/machinery/index.vue")
  },
  {
    name: "offer-reporting-cuid",
    path: "/offer-reporting/:cuid()",
    meta: _91cuid_93Klarle8Yk3MM9aM_45zeQ4t7rqISV7BDZZu_rgfbrlqWoMeta || {},
    component: () => import("/app/pages/offer-reporting/[cuid].vue")
  },
  {
    name: "service-project-view",
    path: "/service-project/:view()",
    component: () => import("/app/pages/service-project/[view].vue")
  },
  {
    name: "machinery-type-maintain",
    path: "/machinery-type/maintain",
    component: () => import("/app/pages/machinery-type/maintain.vue")
  },
  {
    name: "my-hos-quick-sale",
    path: "/my-hos/quick-sale",
    meta: indexRKs_45DLwBGvmefdmPFLpjQScIEW5yWbET_GNsOs_45FkD4Meta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/quick-sale/index.vue")
  },
  {
    name: "tracker-sensor-overview",
    path: "/tracker-sensor/overview",
    component: () => import("/app/pages/tracker-sensor/overview.vue")
  },
  {
    name: "internal-costs-machinery",
    path: "/internal-costs/machinery",
    component: () => import("/app/pages/internal-costs/machinery.vue")
  },
  {
    name: "machinery-accessory-id",
    path: "/machinery-accessory/:id()",
    meta: _91id_93VblqvCEZ2WlzwCrt20KwSSoriCRzCiGZhlnR8uEzqfAMeta || {},
    component: () => import("/app/pages/machinery-accessory/[id].vue")
  },
  {
    name: "service-project-planning",
    path: "/service-project/planning",
    component: () => import("/app/pages/service-project/planning.vue")
  },
  {
    name: "freelancer-sales-sale-all",
    path: "/freelancer-sales/sale/all",
    component: () => import("/app/pages/freelancer-sales/sale/all.vue")
  },
  {
    name: "machinery-creation-view",
    path: "/machinery-creation/:view()",
    component: () => import("/app/pages/machinery-creation/[view].vue")
  },
  {
    name: "online-sales-marketplaces",
    path: "/online-sales/marketplaces",
    component: () => import("/app/pages/online-sales/marketplaces.vue")
  },
  {
    name: "customer-registration-open",
    path: "/customer-registration/open",
    component: () => import("/app/pages/customer-registration/open.vue")
  },
  {
    name: "my-hos-rental-manage",
    path: "/my-hos/rental/manage",
    meta: indexANTpvXsX28gevRhAa4rurNk_FvyeDYS95p0kZkxDKx4Meta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/rental/manage/index.vue")
  },
  {
    name: "overview-foreign-machinery",
    path: "/overview/foreign-machinery",
    component: () => import("/app/pages/overview/foreign-machinery.vue")
  },
  {
    name: "customer-overview-customers",
    path: "/customer-overview/customers",
    component: () => import("/app/pages/customer-overview/customers.vue")
  },
  {
    name: "my-hos-service-project-id",
    path: "/my-hos/service-project/:id()",
    meta: _91id_93hHDqni2eh8pUfvxH3U0iqTk1J4BtUjr7QvnW_FAEAfUMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/service-project/[id].vue")
  },
  {
    name: "service-machinery-accessory",
    path: "/service/machinery-accessory",
    component: () => import("/app/pages/service/machinery-accessory.vue")
  },
  {
    name: "service-repair-type",
    path: "/service/repair-:type()",
    component: () => import("/app/pages/service/repair-[type]/index.vue")
  },
  {
    name: "my-hos-service-project",
    path: "/my-hos/service-project",
    meta: indexjb21qcHt_NIf99CCYHsHPFIsE9IdCB99pJy1ZL5L7m8Meta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/service-project/index.vue")
  },
  {
    name: "shop-buy-machinery-accessory",
    path: "/shop/buy/machinery-accessory",
    meta: machinery_45accessorytgTDsxonVl6IzTV5LyMJhPndbgAo_T0Z3bEkgvhQiAEMeta || {},
    component: () => import("/app/layers/customer-module/pages/shop/buy/machinery-accessory.vue")
  },
  {
    name: "storage-tool-creation-view",
    path: "/storage-tool-creation/:view()",
    component: () => import("/app/pages/storage-tool-creation/[view].vue")
  },
  {
    name: "tracker-sensor-configuration",
    path: "/tracker-sensor/configuration",
    component: () => import("/app/pages/tracker-sensor/configuration.vue")
  },
  {
    name: "inbound-logistics-task-mode",
    path: "/inbound-logistics-task/:mode()",
    component: () => import("/app/pages/inbound-logistics-task/[mode].vue")
  },
  {
    name: "internal-fleet-active-rentals",
    path: "/internal-fleet/active-rentals",
    component: () => import("/app/pages/internal-fleet/active-rentals.vue")
  },
  {
    name: "my-hos-foreign-machinery-id",
    path: "/my-hos/foreign-machinery/:id()",
    meta: _91id_93cHAN_45VcgzYfXZDTJ_WI84tFt8dX4dDLaOQJvdKLYpucMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/foreign-machinery/[id].vue")
  },
  {
    name: "service-project-external-id",
    path: "/service-project/external/:id()",
    component: () => import("/app/pages/service-project/external/[id].vue")
  },
  {
    name: "external-storage-inbound-store",
    path: "/external-storage-inbound/store",
    component: () => import("/app/pages/external-storage-inbound/store.vue")
  },
  {
    name: "external-storage-outbound-load",
    path: "/external-storage-outbound/load",
    component: () => import("/app/pages/external-storage-outbound/load.vue")
  },
  {
    name: "external-storage-position-id",
    path: "/external-storage-position/:id()",
    component: () => import("/app/pages/external-storage-position/[id].vue")
  },
  {
    name: "logistics-details-drive-cuid",
    path: "/logistics-details/drive/:cuid()",
    meta: _91cuid_93DGIaPHnSnMyf4pJvJ_XYb2X8HJldRyHX4KzOw7jZJlYMeta || {},
    component: () => import("/app/pages/logistics-details/drive/[cuid].vue")
  },
  {
    name: "my-hos-foreign-machinery",
    path: "/my-hos/foreign-machinery",
    meta: indexJI8rBLrPXTsvhp_45xmZeYl3e_45XFr7J2iggLQHb1lUQM4Meta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/foreign-machinery/index.vue")
  },
  {
    name: "customer-overview-customer-user",
    path: "/customer-overview/customer-user",
    component: () => import("/app/pages/customer-overview/customer-user.vue")
  },
  {
    name: "customer-registration-completed",
    path: "/customer-registration/completed",
    component: () => import("/app/pages/customer-registration/completed.vue")
  },
  {
    name: "internal-fleet-company-vehicles",
    path: "/internal-fleet/company-vehicles",
    component: () => import("/app/pages/internal-fleet/company-vehicles.vue")
  },
  {
    name: "logistics-details-issued-cuid",
    path: "/logistics-details/issued/:cuid()",
    meta: _91cuid_93SXKYga2EWwYfltdr_453e8gzWzj4J2_c7KjFnoE39EmZIMeta || {},
    component: () => import("/app/pages/logistics-details/issued/[cuid].vue")
  },
  {
    name: "service-project-fitter-issuance",
    path: "/service-project/fitter-issuance",
    component: () => import("/app/pages/service-project/fitter-issuance.vue")
  },
  {
    name: "external-storage-inbound-approve",
    path: "/external-storage-inbound/approve",
    component: () => import("/app/pages/external-storage-inbound/approve.vue")
  },
  {
    name: "external-storage-inbound-request",
    path: "/external-storage-inbound/request",
    component: () => import("/app/pages/external-storage-inbound/request.vue")
  },
  {
    name: "external-storage-storage-product",
    path: "/external-storage/storage-product",
    component: () => import("/app/pages/external-storage/storage-product.vue")
  },
  {
    name: "internal-fleet-my-active-rentals",
    path: "/internal-fleet/my-active-rentals",
    component: () => import("/app/pages/internal-fleet/my-active-rentals.vue")
  },
  {
    name: "partner-sales-released-machinery",
    path: "/partner-sales/released-machinery",
    component: () => import("/app/pages/partner-sales/released-machinery.vue")
  },
  {
    name: "external-storage-outbound-request",
    path: "/external-storage-outbound/request",
    component: () => import("/app/pages/external-storage-outbound/request.vue")
  },
  {
    name: "internal-fleet-terminated-rentals",
    path: "/internal-fleet/terminated-rentals",
    component: () => import("/app/pages/internal-fleet/terminated-rentals.vue")
  },
  {
    name: "marketing-storage-tool-categories",
    path: "/marketing/storage-tool-categories",
    component: () => import("/app/pages/marketing/storage-tool-categories.vue")
  },
  {
    name: "my-hos-rental-manage-accessCode",
    path: "/my-hos/rental/manage/:accessCode()",
    meta: _91accessCode_93CMRSyjJpDDxAU7r_45cYpK2fNS9CxCU11jhX8x69yQD98Meta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/rental/manage/[accessCode].vue")
  },
  {
    name: "internal-costs-machinery-accessory",
    path: "/internal-costs/machinery-accessory",
    component: () => import("/app/pages/internal-costs/machinery-accessory.vue")
  },
  {
    name: "logistics-details-collected-cuid",
    path: "/logistics-details/collected/:cuid()",
    meta: _91cuid_93ZEW65wnY7lKnoDI2q6saArod8C4yL0Fv3_siw8AOVzMMeta || {},
    component: () => import("/app/pages/logistics-details/collected/[cuid].vue")
  },
  {
    name: "offer-templates-position-templates",
    path: "/offer-templates/position-templates",
    component: () => import("/app/pages/offer-templates/position-templates.vue")
  },
  {
    name: "freelancer-sales-released-machinery",
    path: "/freelancer-sales/released-machinery",
    component: () => import("/app/pages/freelancer-sales/released-machinery.vue")
  },
  {
    name: "service-external-workshop-employees",
    path: "/service/external-workshop-employees",
    component: () => import("/app/pages/service/external-workshop-employees.vue")
  },
  {
    name: "external-storage-retrieved-positions",
    path: "/external-storage/retrieved-positions",
    component: () => import("/app/pages/external-storage/retrieved-positions.vue")
  },
  {
    name: "freelancer-sales-sale-current-view",
    path: "/freelancer-sales/sale/current/:view()",
    meta: _91view_93J0w1Sj3188SppTfH3wUO4wisjZRgD9k_B2hkD0XjJdkMeta || {},
    component: () => import("/app/pages/freelancer-sales/sale/current/[view].vue")
  },
  {
    name: "external-storage-outbound-task-mode",
    path: "/external-storage-outbound/task/:mode()",
    component: () => import("/app/pages/external-storage-outbound/task/[mode].vue")
  },
  {
    name: "external-storage-positions-in-storage",
    path: "/external-storage/positions-in-storage",
    component: () => import("/app/pages/external-storage/positions-in-storage.vue")
  },
  {
    name: "my-hos-service-project-reporting-id",
    path: "/my-hos/service-project/reporting/:id()",
    meta: _91id_934fKCFxyTx17CEQEU5_45qORg0op_45etM97OKyFVkxmLT1kMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/service-project/reporting/[id].vue")
  },
  {
    name: "service-project-external-stakeholders",
    path: "/service-project/external-stakeholders",
    component: () => import("/app/pages/service-project/external-stakeholders.vue")
  },
  {
    name: "my-hos-service-project-reporting",
    path: "/my-hos/service-project/reporting",
    meta: indexmB4lxjsfAoiDvL9ZxLz5gqHR9dHJ_QcjxsXKCeY0BNoMeta || {},
    component: () => import("/app/layers/customer-module/pages/my-hos/service-project/reporting/index.vue")
  },
  {
    name: "rental-pricing-machinery-machineryId",
    path: "/rental/pricing/machinery/:machineryId()",
    component: () => import("/app/pages/rental/pricing/machinery/[machineryId].vue")
  },
  {
    name: "service-project-service-project-return",
    path: "/service-project/service-project-return",
    component: () => import("/app/pages/service-project/service-project-return.vue")
  },
  {
    name: "service-repair-type-id-defectId",
    path: "/service/repair-:type()/:id()/:defectId?",
    component: () => import("/app/pages/service/repair-[type]/[id]/[[defectId]].vue")
  },
  {
    name: "service-project-external-overview-view",
    path: "/service-project/external/overview/:view()",
    component: () => import("/app/pages/service-project/external/overview/[view].vue")
  },
  {
    name: "driver-external-storage-inbound-task-id",
    path: "/driver/external-storage/inbound-task/:id()",
    component: () => import("/app/pages/driver/external-storage/inbound-task/[id].vue")
  },
  {
    name: "external-storage-used-storage-space-check",
    path: "/external-storage/used-storage-space-check",
    component: () => import("/app/pages/external-storage/used-storage-space-check.vue")
  },
  {
    name: "offer-templates-position-template-bundles",
    path: "/offer-templates/position-template-bundles",
    component: () => import("/app/pages/offer-templates/position-template-bundles.vue")
  },
  {
    name: "customer-overview-other-invoice-recipients",
    path: "/customer-overview/other-invoice-recipients",
    component: () => import("/app/pages/customer-overview/other-invoice-recipients.vue")
  },
  {
    name: "driver-external-storage-outbound-task-id",
    path: "/driver/external-storage/outbound-task/:id()",
    component: () => import("/app/pages/driver/external-storage/outbound-task/[id].vue")
  },
  {
    name: "external-storage-administration-storage-ride",
    path: "/external-storage-administration/storage-ride",
    component: () => import("/app/pages/external-storage-administration/storage-ride.vue")
  },
  {
    name: "external-storage-administration-storage-user",
    path: "/external-storage-administration/storage-user",
    component: () => import("/app/pages/external-storage-administration/storage-user.vue")
  },
  {
    name: "external-storage-invoicing-storagePositionId",
    path: "/external-storage/invoicing/:storagePositionId()",
    component: () => import("/app/pages/external-storage/invoicing/[storagePositionId].vue")
  },
  {
    name: "external-storage-administration-storage-project",
    path: "/external-storage-administration/storage-project",
    component: () => import("/app/pages/external-storage-administration/storage-project.vue")
  },
  {
    name: "rental-pricing-machinery-type-machineryTypeId",
    path: "/rental/pricing/machinery-type/:machineryTypeId()",
    component: () => import("/app/pages/rental/pricing/machinery-type/[machineryTypeId].vue")
  },
  {
    name: "external-storage-administration-storage-reporting",
    path: "/external-storage-administration/storage-reporting",
    component: () => import("/app/pages/external-storage-administration/storage-reporting.vue")
  },
  {
    name: "external-storage-administration-storage-load-carrier",
    path: "/external-storage-administration/storage-load-carrier",
    component: () => import("/app/pages/external-storage-administration/storage-load-carrier.vue")
  },
  {
    name: "external-storage-administration-logistics-task-overview",
    path: "/external-storage-administration/logistics-task-overview",
    component: () => import("/app/pages/external-storage-administration/logistics-task-overview.vue")
  },
  {
    name: "external-storage-administration-storage-fixed-delivery-vehicles",
    path: "/external-storage-administration/storage-fixed-delivery-vehicles",
    component: () => import("/app/pages/external-storage-administration/storage-fixed-delivery-vehicles.vue")
  }
]